import {useQuery} from 'react-query'
import {getStudentById} from '../app/pages/student/api'
import ViewAll from './ViewAll'
import viewProps from '../app/pages/viewProps'
import {getGuardianById} from '../app/pages/guardian/api'

const GuardianDetails = ({guardianId}: {guardianId: string}) => {
  const {data, isLoading, error} = useQuery({
    queryKey: ['guardian', guardianId],
    queryFn: () => getGuardianById(guardianId),
    enabled: !!guardianId,
    refetchOnWindowFocus: false,
  })

  if (isLoading) return <p>Loading student...</p>
  if (error) return <p>Error loading student: {(error as Error).message}</p>
  const orderedFields = [
    ...Object.entries(viewProps.Guardian.primaryFieldsToLabelMap),
    ...Object.entries(viewProps.Guardian.secondaryFieldsToMap),
  ]
  return <ViewAll data={data.data} cellModifier={{}} fieldOrder={orderedFields} />
}
export default GuardianDetails
